module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-container"
  }, [_c('Menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shrink),
      expression: "!shrink"
    }],
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "theme": "dark",
      "width": "auto",
      "active-name": _vm.$route.name,
      "accordion": "",
      "open-names": _vm.openedSubmenuArr
    },
    on: {
      "on-select": _vm.changeMenu,
      "on-open-change": _vm.changeSubmenu
    }
  }, [_c('div', {
    staticClass: "layout-logo-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("运营管理后台")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "notice"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("通知")])], 1), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "materialManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "images"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("素材管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "weChatMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信文章")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "productManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网产品")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "newsManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网新闻")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "otherMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("其他")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "appManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "android-apps"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "webAPP"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网展示")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "messageManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("消息管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "templateMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("模板消息推送")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "helpMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人求助消息")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "usersMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户反馈消息")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "weChatMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信公共账号消息")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "usersManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "blindUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人用户")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "volunteerUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者用户")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "count"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pie"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("统计")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "totalCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("总体数据")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "appCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP数据")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "volunteerCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者数据")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "setup"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "gear-b"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("设置")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "publicSetting"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("公众号设置")])])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shrink),
      expression: "shrink"
    }],
    staticClass: "dropdown-container",
    attrs: {
      "active-name": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "notice"
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.changeMenu('notice')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down",
      "size": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "materialManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "images",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "weChatMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信文章")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "productManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网产品")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "newsManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网新闻")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "otherMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("其他")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "appManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-apps",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "webAPP"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网展示")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "messageManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "templateMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("模板消息推送")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "helpMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人求助消息")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "usersMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户反馈消息")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "weChatMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信公共账号消息")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "usersManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "blindUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人用户")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "volunteerUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者用户")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "count",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.changeMenu('AdminHome')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pie",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "totalCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("总体数据")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "appCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP数据")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "volunteerCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者数据")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "setup",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "gear-b",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "publicSetting"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("公众号设置")])])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-logo-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2beb48","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/admin-blocks/menu-lists.vue
// module id = tmQQ
// module chunks = 0